import { ReactNode } from 'react';
import { Popover as BriksPopover } from '@huspy/briks-web';

export const Popover = ({
  title,
  triggerButton,
  children,
}: {
  title: string;
  triggerButton: ReactNode;
  children: ReactNode;
}) => (
  <BriksPopover.Root>
    <BriksPopover.Trigger asChild>{triggerButton}</BriksPopover.Trigger>
    <BriksPopover.Positioner>
      <BriksPopover.Content>
        <BriksPopover.Arrow>
          <BriksPopover.ArrowTip />
        </BriksPopover.Arrow>
        <BriksPopover.Title>{title}</BriksPopover.Title>
        {children}
      </BriksPopover.Content>
    </BriksPopover.Positioner>
  </BriksPopover.Root>
);
